<template>
<div>

    <CCard
        v-bind:key="empresa.codEmpresa"
        v-for="empresa in empresas"
    >
        <CCardHeader>
            <CRow>
                <CCol col="12">
                    <CRow class="justify-content-center align-items-center margenes">
                        <div>
                            <strong>
                                <h5>
                                    <span  v-show="provTabPrincipal"  class="mr-1" @click="enviarNuevoTab(empresa)" v-tippy="getBaseTippy(`Desplegar en Pestaña`)">
                                        <CIcon name="cil-object-ungroup" />
                                    </span>
                                    {{ empresa.nombreEmpresa }}({{empresa.codEmpresa}}) 
                                </h5>
                            </strong>
                        </div>
                    </CRow>

                    <!-- Estado -->
                    <CRow class="justify-content-center align-items-center margenes">
                        <CBadge
                            class="m-1"
                            style="font-size: 0.7rem; font-weight: normal "
                            :content="
                                empresa.estado == 1
                                ? 'En Revisión'
                                : empresa.estado == 2
                                ? 'Rechazado ' +
                                    empresa.mensajeRespuesta +
                                    ' (' +
                                    $utils.formatFechaEnDistancia(empresa.fechaMensaje) +
                                    ')'
                                : empresa.estado == 3
                                ? 'Aceptado'
                                : 'En Proceso'
                            "
                            v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                            }"
                            shape="pill"
                            :color="
                                empresa.estado == 1
                                ? 'info'
                                : empresa.estado == 2
                                ? 'danger'
                                : empresa.estado == 3
                                ? 'success'
                                : 'secondary'
                            "
                            >
                            <CIcon
                                v-if="empresa.estado == 1"
                                style="width: 20px; height: 20px"
                                :content="$options.freeSet.cilArrowCircleRight"
                            />
                            <CIcon
                                v-else-if="empresa.estado == 2"
                                style="width: 20px; height: 20px"
                                :content="$options.freeSet.cilXCircle"
                            />
                            <CIcon
                                v-else-if="empresa.estado == 3"
                                style="width: 20px; height: 20px"
                                :content="$options.freeSet.cilCheckCircle"
                            />
                            
                        </CBadge>
                        <span style="font-size: 1rem">
                            {{ estadoEmpresa(empresa) }}
                        </span>
                    </CRow>
                    
                    <!-- Periodo -->
                    <CRow class="justify-content-center align-items-center margenes">
                        <CBadge
                            v-show="empresa.periodoCerrado"
                            class="m-1"
                            :content="`Periodo Cerrado ${
                                empresa.fechaPeriodoCerrado == undefined ||
                                empresa.fechaPeriodoCerrado == ''
                                ? 'por aplicación Edig'
                                : $utils.formatFechaEnDistancia(empresa.fechaPeriodoCerrado)
                            }`"
                            v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                            }"
                            shape="pill"
                            style="
                                font-size: 0.7rem;
                                font-weight: normal;
                                background-color: #29235c;
                                color: white;
                            "
                            >
                            <CIcon
                                style="width: 20px; height: 20px"
                                :content="$options.freeSet.cilLockLocked"
                            />
                        </CBadge>

                        <CButton
                            v-show="
                                tipoDocumento.valor != 'contratos' &&
                                !empresa.periodoCerrado &&
                                empresa.estado == 3
                            "
                            shape="pill"
				            v-tippy="getBaseTippy(`Cerrar Período`)"
                            style="font-size: 12px;"
                            class="btnPrincipalVapp"
                            @click="cerrarPeriodo(empresa)"
                            >
                            <CIcon
                                style="width: 20px; height: 20px"
                                :content="$options.freeSet.cilDoor"
                            /> Cerrar Período
                        </CButton>

                        <CButton
                        v-show="empresa.periodoCerrado && empresa.estado == 3"
                        shape="pill"
                        v-tippy="getBaseTippy(`Abrir Periodo`)"
                        style="font-size: 11px; padding: 1px"
                        class="btnPrincipalVapp"
                        @click="abrirPeriodo(empresa)"
                        >
                        <CIcon
                            style="width: 20px; height: 20px"
                            :content="$options.freeSet.cilRoom"
                        /> Abrir Período
                        </CButton>   
                    </CRow>

                    <!-- Enviar Empresa -->
                    <CRow class="justify-content-center align-items-center margenes">
                        <span>
                            <CButton
                                class="btnPrincipalVapp w-100"
                                shape="pill"
                                v-show="empresa.enviandoEmpresa"
                            >
                                <CIcon
                                :content="$options.freeSet.cilLoopCircular"
                                class="imgr"
                                />
                                <span v-show="usaPortalEmpresa && !tipoUserAdmin"
                                >Enviando Empresa</span
                                >
                                <span v-show="usaPortalEmpresa && tipoUserAdmin"
                                >Aceptando</span
                                >
                                <span v-show="!usaPortalEmpresa && tipoUserAdmin"
                                >Aceptando</span
                                >
                            </CButton>
                        </span>

                        <span v-show="usaPortalEmpresa" class="margenes">
                            <CButton
                            shape="pill"
                            class="btnPrincipalVapp mr-1 w-100"
                            v-show="
                                !empresa.enviandoEmpresa &&
                                empresa.estado != 1 &&
                                empresa.infoEmpresa.totalTrabajadores > 0 &&
                                !empresa.enviarEmpresa
                            "
                            v-tippy="getBaseTippy(empresa.userNotificar.length == 0 ? '(!) OJO - No tiene usuario para revision' : 'Enviar a Revision')"
                            @click="enviarEmpresa(empresa)"
                            >
                            <i class="pi pi-upload"></i>
                            {{ empresa.estado == 3 ? "Volver a Enviar" : "Enviar" }}
                            <span v-show="empresa.userNotificar.length == 0" class="alertaSinUsuario">!</span>
                            </CButton>
                        </span>

                        <span v-show="tipoUserAdmin || (!tipoUserAdmin && !usaPortalEmpresa)" class="margenes">
                            <CButton
                            class="btnPrincipalVapp w-100"
                            shape="pill"
                            v-show="
                                !empresa.enviandoEmpresa &&
                                empresa.estado != 1 &&
                                empresa.estado != 3 &&
                                empresa.infoEmpresa.totalTrabajadores > 0 &&
                                !empresa.enviarEmpresa
                            "
                            @click="empresa.enviarEmpresa = true"
                            >
                            <i class="pi pi-check"></i>
                            Aceptar
                            </CButton>

                            <CButtonGroup
                            size="sm"
                            class="mx-1"
                            v-show="empresa.enviarEmpresa"
                            >
                            <CButton
                                color="success"
                                size="sm"
                                @click="
                                aceptarEmpresa(empresa);
                                empresa.enviarEmpresa = false;
                                "
                                content="Aceptar Empresa"
                                v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                                followCursor: true,
                                }"
                            >
                                <CIcon name="cil-check-circle" />
                            </CButton>

                            <CButton
                                content="Cancelar"
                                v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                                followCursor: true,
                                }"
                                color="danger"
                                @click="empresa.enviarEmpresa = false"
                                size="sm"
                                ><CIcon name="cil-x-circle" />
                            </CButton>
                            </CButtonGroup>

                            <span v-show="empresa.infoEmpresa.totalTrabajadores == 0">
                                <CButton
                                    size="sm"
                                    variant="ghost"
                                    style="
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        gap: 0.5rem;
                                        text-align: center;
                                        width: 100%;
                                        font-size: 1rem;
                                    "
                                >
                                    <CIcon :content="$options.freeSet.cilWarning" 
                                        style="width: 1.5rem;"
                                    />
                                    No hay informacion para ser Aceptada
                                </CButton>
                            </span>
                        </span>

                        <span v-show="!empresa.enviandoEmpresa && empresa.estado == 1" class="margenes">
                            <CButton
                                style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    gap: 0.5rem;
                                "
                                :disabled="empresa.cancelandoEnvio"
                                class="btnPrincipalVapp"
                                size="sm"
                                content="Cancelar revisión Empresa"
                                v-tippy="{
                                    placement: 'top',
                                    arrow: true,
                                    arrowType: 'round',
                                    animation: 'fade',
                                    theme: 'google',
                                    followCursor: true,
                                }"
                                @click="cancelarRevision(empresa)"
                                >
                                <CIcon
                                    :class="empresa.cancelandoEnvio ? 'imgr' : ''"
                                    :content="$options.freeSet.cilXCircle"
                                />
                                Cancelar Revisión
                            </CButton>
                        </span>

                        <CRow v-show="
                                    !empresa.enviandoEmpresa &&
                                    empresa.estado != 1 &&
                                    empresa.infoEmpresa.totalTrabajadores > 0 &&
                                    !empresa.enviarEmpresa
                                "
                                class="centrar_row"
                                >
                            <span
                                    v-show="empresa.userNotificar.length == 0"
                                    style="color: red; font-size: 14px; font-weight: bold"
                                    >! OJO - No tiene usuario para revision</span
                                >
                        </CRow>
                    </CRow>


                    <CRow class="justify-content-center align-items-center margenes">
                        <div>
                            ({{empresa.infoEmpresa.totalTrabajadores}} Personas)
                        </div>
                    </CRow>
                    <!-- Expandir -->
                    <CRow class="justify-content-center align-items-center margenes">
                        <span>
                            <div>
                                <CLink
                                    class="card-header-action btn-minimize float-right"
                                    @click="desplegarEmpresa(empresa)"
                                >
                                    <CIcon
                                        :name="`cil-chevron-${empresa.desplegada ? 'bottom' : 'top'}`"
                                    />
                                </CLink>
                            </div>
                        </span>
                    </CRow>
                </CCol>
            </CRow>
        </CCardHeader>

        
        <CCollapse :show="empresa.desplegada" :duration="400">
            <CCardBody>
                <!-- Filtro Trabajador -->
                <CRow>
                    <CCol col="12" class="p-0">
                        <FiltroTrabajadoresComponente
                            :ref="empresa.idEmpresa + 'filtroTrab2'"
                            :empresaSelected="empresa"
                            :tipoDocSelected="tipoDocumento"
                            :mesSelected="mesSeleccionado"
                            :anioSelected="periodoSeleccionado"
                            @seleccionarTrab="filtrarTrabajadores($event, empresa)"
                        />
                    </CCol>
                </CRow>

                <!-- Filtro Cargo Trabajador -->
                <CRow>
                    <CCol col="12" class="p-0">
                        <OpcionesFiltrosTrabajadores
                            :opcionesFiltrosTrabajadores="empresa.opcionesFiltrosTrabajadores"
                            @seleccionarFiltro="seleccionFiltro($event, empresa)"
                        />
                    </CCol>
                </CRow>

                <!-- Boton Hamgurguesa Opciones Documentos -->
                <CRow>
                    <CCol col="12">
                        <CDropdown
                        color="drpdwn-menu"
                        class="mt-1"
                        size="sm"
                        v-show="empresa.trabajadores.length > 0"
                        > 
                        <template #toggler-content>
                            <!--:disabled="empresa.isActualizandoDocumentos || empresa.isLoadingEnvioTodos || empresa.isLoadingGenerarDocumento || empresa.isDescargando"-->
                            <CIcon
                            :class="
                                empresa.isActualizandoDocumentos ||
                                empresa.isLoadingEnvioTodos ||
                                empresa.isLoadingGenerarDocumento ||
                                empresa.isDescargando
                                ? 'imgr'
                                : ''
                            "
                            :content="$options.freeSet.cilApplications"
                            />
                            Opciones Documentos
                            <!--<CIcon :content="$options.freeSet.cilOptions" />-->
                        </template>
                        <div role="group">
                            <CDropdownHeader
                            v-show="empresa.periodoCerrado"
                            class="font-weight-bold"
                            content="Opciones deshabilitadas por que el periodo se encuentra cerrado"
                            v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                                followCursor: true,
                            }"
                            >
                            <CIcon
                                style="color: #f9b115"
                                :content="$options.freeSet.cilWarning"
                            />
                            Hay Opciones deshabilitadas </CDropdownHeader
                            ><!--icono Periodo Cerrado-->

                            <!--<CDropdownItem
                            :disabled="
                                empresa.isActualizandoDocumentos ||
                                empresa.isLoadingEnvioTodos ||
                                empresa.isLoadingGenerarDocumento ||
                                empresa.isDescargando ||
                                empresa.estado == 1 ||
                                empresa.estado == 3
                            "
                            v-show="tipoDocumento.permiteSubirDocs"
                            @click="mostrarSubirArchivos(empresa)"
                            >
                            
                            <CIcon
                                class="mr-1"
                                :content="
                                empresa.periodoCerrado
                                    ? $options.freeSet.cilWarning
                                    : $options.freeSet.cilCloudUpload
                                "
                            />
                            Subir Documentos
                            </CDropdownItem>-->

                            <!--<CDropdownItem
                            :content="
                                empresa.mostrarMensajeActualizacionDocumentos
                                ? empresa.mensajeActualizacionDocs
                                : 'Actualizar Documentos'
                            "
                            v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                                followCursor: true,
                            }"
                            :disabled="
                                empresa.isActualizandoDocumentos ||
                                empresa.isLoadingEnvioTodos ||
                                empresa.isLoadingGenerarDocumento ||
                                empresa.isDescargando ||
                                empresa.estado == 3
                            "
                            v-show="tipoDocumento.valor == 'liquidaciones'"
                            @click="actualizarDocumentosEmpresa(empresa)"
                            >
                            <CIcon
                                class="mr-1"
                                :class="empresa.isActualizandoDocumentos ? 'imgr' : ''"
                                :content="
                                empresa.periodoCerrado
                                    ? $options.freeSet.cilWarning
                                    : $options.freeSet.cilLoopCircular
                                "
                            />
                            {{
                                empresa.isActualizandoDocumentos
                                ? "Actualizando "
                                : "Actualizar "
                            }}
                            Documentos

                            <CIcon
                                class="ml-1"
                                v-show="empresa.mostrarMensajeActualizacionDocumentos"
                                :content="$options.freeSet.cilInfo"
                            />
                            </CDropdownItem>-->

                            <!--<CDropdownItem 
                                                                    v-show="tipoDocumentoSelected.permiteGenerarDoc" 
                                                                    :disabled="empresa.isActualizandoDocumentos || empresa.isLoadingEnvioTodos || empresa.isLoadingGenerarDocumento || empresa.isDescargando"
                                                                    @click="generarDocumentos(empresa)" >
                                                                    <CIcon class="mr-1" 
                                                                        :class="(empresa.isLoadingGenerarDocumento)?'imgr':''" 
                                                                        :content="$options.freeSet.cilLibraryAdd" /> Generar Documentos
                                                                </CDropdownItem>-->

                            <CDropdownItem
                            :content="empresa.txtEnviarTodos"
                            v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                                followCursor: true,
                            }"
                            v-show="empresa.hayDocumentosTrabajador"
                            :disabled="
                                empresa.isActualizandoDocumentos ||
                                empresa.isLoadingEnvioTodos ||
                                empresa.isLoadingGenerarDocumento ||
                                empresa.isDescargando
                            "
                            @click="enviaraTodos(empresa)"
                            >
                            <CIcon
                                class="mr-1"
                                :class="empresa.isLoadingEnvioTodos ? 'imgr' : ''"
                                :content="$options.freeSet.cilEnvelopeLetter"
                            />
                            Enviar Documentos
                            </CDropdownItem>
                        </div>
                        <div role="group" v-show="empresa.hayDocumentosTrabajador">
                            <CDropdownDivider />
                            <CDropdownHeader class="font-weight-bold">
                            <CIcon
                                class="mr-1"
                                :class="empresa.isDescargando ? 'imgr' : ''"
                                :content="$options.freeSet.cilCloudDownload"
                            />
                            Descarga de Documentos
                            </CDropdownHeader>
                            <CDropdownItem
                            :disabled="
                                empresa.isActualizandoDocumentos ||
                                empresa.isLoadingEnvioTodos ||
                                empresa.isLoadingGenerarDocumento ||
                                empresa.isDescargando
                            "
                            content="Descargar un Archivo con todos los documentos"
                            v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                                followCursor: true,
                            }"
                            @click="descargarArchivo('merge', empresa)"
                            >
                            <CIcon
                                class="mr-1"
                                :class="empresa.isDescargando ? 'imgr' : ''"
                                :content="$options.freeSet.cilSwapVertical"
                            />
                            Documentos Unificados
                            </CDropdownItem>
                            <CDropdownItem
                            content="Descargar todos los documentos comprimidos"
                            v-tippy="{
                                placement: 'top',
                                arrow: true,
                                arrowType: 'round',
                                animation: 'fade',
                                theme: 'google',
                            }"
                            :disabled="
                                empresa.isActualizandoDocumentos ||
                                empresa.isLoadingEnvioTodos ||
                                empresa.isLoadingGenerarDocumento ||
                                empresa.isDescargando
                            "
                            @click="descargarArchivo('zip', empresa)"
                            >
                            <CIcon
                                class="mr-1"
                                :class="empresa.isDescargando ? 'imgr' : ''"
                                :content="$options.freeSet.cilCompress"
                            />
                            Documentos comprimidos
                            </CDropdownItem>
                        </div>
                        </CDropdown>
                    </CCol>
                </CRow>

                <div class="margenes">
                    <subida-documentos
                        v-show="empresa.mostrarSubirDocumentos"
                        :empresa="empresa">
                    </subida-documentos>

                    <CargandoInfo
                        :mostrarCarga="empresa.isLoadingTrabajadores"
                        :mensajeInfo="'Obteniendo sus Trabajadores'"
                    />

                    <TablaTrabajadoresDocumentos 
                        v-show="!empresa.isLoadingTrabajadores"
                        :portContador="true"
                        :empresa="empresa"
                        :periodoCerrado="empresa.periodoCerrado"
                        :periodoSelected="periodoSeleccionado"
                        :mesSelected="mesSeleccionado"
                        :trabajadores="empresa.trabajadores"
                        :loading="false"
                        :paginacion="empresa.paginacion"
                        :tipoDocumentoSelected="tipoDocumento"
                        :totalTrabajadoresDocumentos="empresa.totalTrabajadoresDocumentos"
                        :totalTrabajadores="empresa.totalTrabajadores"
                        :mostrarPeriodo="mostrarPeriodo"
                        @obtenerTrabajadores="getTrabajadoresInfoEmpresa(empresa)"
                    />

                </div>
            </CCardBody>
        </CCollapse>   
    </CCard>
    
</div>
</template>

<script>
import apiUrls from "@/views/utils/apiUrls";
import axios from "axios";
import cons from "@/const";
import { freeSet } from "@coreui/icons";
import * as util from '@/views/utils/utilsFunctions'

import ModalInfoEmpresa from './ModalInfoEmpresa';
import FiltroTrabajadoresComponente from './FiltroTrabajadoresComponente';
import OpcionesFiltrosTrabajadores from './filtros/OpcionesFiltrosTrabajadores';
import SubidaDocumentos from './SubidaDocumentos';
import CargandoInfo from '../../utils/CargandoInfo';
import TablaTrabajadoresDocumentos from './TablaTrabajadoresDocumentos';
import FileUpload from 'vue-upload-component';

export default {
    name: "InfoEmpresaMovil",
    freeSet,
    components:{
        ModalInfoEmpresa,
        FiltroTrabajadoresComponente,
        OpcionesFiltrosTrabajadores,
        SubidaDocumentos,
        CargandoInfo,
        TablaTrabajadoresDocumentos,
        FileUpload
    },
    props:{
        empresas: Array,
        tipoDocumento: Object,
        mesSeleccionado: Object,
        periodoSeleccionado: Object,
        mostrarPeriodo: Boolean,
        provTabPrincipal: Boolean,
    },
    data(){
        return{
            urlBase: cons.port + "://" + cons.ipServer,

            tokenLogin: JSON.parse(this.$cookie.get("userLogginToken")).tokenUsuario,
            tipoUserAdmin: JSON.parse(this.$cookie.get("userLogginToken"))
                .tipoUsuario,
            idCliente: JSON.parse(this.$cookie.get("userLogginToken")).idCliente,
            usaPortalEmpresa: JSON.parse(this.$cookie.get("userLogginToken"))
                .usaPortalEmpresa,

            /** Modal Envio Empresa */
            isLoadingEnviandoEmpresa: false,

            mensajeCorreoInvalido: false,
            mostrarModalEnvioEmpresa: false,
            editCorreoEncargado: false,
            empresaEnviada: false,
            msjEnviandoRevision: "Enviando...",
            respEmpresaEnviar: {},
            /** Fin Modal Envio Empresa */


        }
    },
    methods:{
        enviarNuevoTab: function(empresa){
            this.$emit('enviarNuevoTab', {
                codEmpresa: empresa.codEmpresa,
                nombreEmpresa: empresa.nombreEmpresa,
            })
        },
        mostrarInfoEmpresa: function (empresa) {
            this.$emit("mostrarInfoEmpresa", empresa);
        },
        cerrarPeriodo: function (empresa) {
            this.$emit("cerrarPeriodo", empresa);
        },
        abrirPeriodo: function (empresa) {
            this.$emit("abrirPeriodo", empresa);
        },
        enviarEmpresa: function (empresa) {
            this.$emit("enviarEmpresa", empresa);
        },
        aceptarEmpresa: function (empresa) {
            this.$emit("aceptarEmpresa", empresa)
        },
        cancelarRevision: function(empresa){
            this.$emit("cancelarRevision", empresa)
        },
        desplegarEmpresa: function (empresa) {
            let refUnico = `${empresa.idEmpresa}filtroTrab2`;
            empresa.desplegada = !empresa.desplegada;
            if (empresa.desplegada){
                this.getTrabajadoresInfoEmpresa(empresa);
            }
            //this.$emit("obtenerTrabajadores", true, empresa);
            //this.$refs[refUnico][0].getTrabajadores();
            //let key = "tblTrabajadores" + empresa.codEmpresa;
            //this.getTrabajadores(empresa.desplegada, empresa);
        },
        actualizarFiltro: function (empresa) {
            let refUnico = `${empresa.idEmpresa}filtroTrab2`;

            //this.$refs[refUnico][0].getTrabajadores();
        },
        seleccionFiltro: function (evento, empresa) {
            empresa.opcionSeleccionadaFiltro = evento;
            this.getTrabajadoresInfoEmpresa(empresa);
        },
        filtrarTrabajadores: function (evento, empresa) {
            empresa.trabajadoresFiltrados = evento;
            empresa.paginacion.current = 1;

            this.getTrabajadoresInfoEmpresa(empresa);
        },
        seleccionFiltro: function (evento, empresa) {
            empresa.opcionSeleccionadaFiltro = evento;
            this.getTrabajadoresInfoEmpresa(empresa);
        },
        /*mostrarSubirArchivos: function(empresa){
            empresa.mostrarSubirDocumentos = !empresa.mostrarSubirDocumentos

            this.empresaSeleccionadaSubirArchivos = empresa
            this.subirDocumentosModal = true
            
            if(empresa.mostrarSubirDocumentos){
                this.generarLinkSubidaArchivos(empresa)
            }
        },
        generarLinkSubidaArchivos: function (empresa) {
            this.$emit("generarLinkSubidaArchivos", empresa)
        },
        actualizarDocumentosEmpresa: function (empresa) {
            this.$emit("actualizarDocumentosEmpresa", empresa)
        },*/
        descargarArchivo: function(tipoDescarga, empresa){
            this.$emit("descargarArchivo", tipoDescarga, empresa)

            /* empresa.isDescargando = true
            
            let url = this.urlBase + `/descargar_documentos/`
            let trabajadores = []
            if(empresa.trabajadoresFiltrados != null && empresa.trabajadoresFiltrados.length > 0){
                empresa.trabajadoresFiltrados.forEach(trabajador => {
                    trabajadores.push({"rutTrabajador": trabajador.rutTrabajador})
                });
            }
            axios({
                url: url,
                method: 'POST',
                "data": {
                    "tipoBd": "REMU",
                    "tipoDescarga": tipoDescarga,
                    "codEmpresa": empresa.codEmpresa,
                    "idEmpresa": empresa.idEmpresa,
                    "filtrarPorPeriodo": this.mostrarPeriodo,
                    "anioPeriodo": (this.periodoSeleccionado != null) ? this.periodoSeleccionado.valor : null,
                    "mesPeriodo":(this.mesSeleccionado != null) ? this.mesSeleccionado.valor : null,
                    "tipoDocumento": (this.tipoDocumento != null) ? this.tipoDocumento.valor : null,
                    "infoTrabajadores": {
                        "trabajadoresSelected": [],
                        "trabajadores": trabajadores
                    }
                },
                "headers": {
                    'Authorization': `${this.tokenLogin}`
                },

            }).then((response) => {
                //this.msjDescargando = "Iniciando Descarga"

                //this.$notification.success(response.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
                //this.mostrarNotificaciones(1, response.data.mensajeGeneral)
                const link = document.createElement('a')
                link.href = response.data.archivo.link
                link.download = response.data.archivo.nombre
                link.click()
                URL.revokeObjectURL(link.href)

                //this.$notification.success("Iniciando Descarga", {  timer: 10, position:"bottomRight", showCloseIcn:true});
                this.mostrarNotificaciones(1, `${response.data.mensajeGeneral}, Iniciando Descarga`)

            }, error => {
                this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                //this.$notification.error(error.response.data.mensajeGeneral, {  timer: 10, position:"bottomRight", showCloseIcn:true});
            })
            .finally(() => {
                empresa.isDescargando = false
            }); */
        },
        getTrabajadoresInfoEmpresa: function (empresa) {
            if (empresa.trabajadoresFiltrados.length > 0) {
                empresa.txtEnviarTodos =
                "Enviar Documentos a Trabajadores Seleccionados";
                empresa.txtActualizarDocs =
                "Actualizar Documentos Trabajadores Seleccionados";
                empresa.txtDescargarDocumentos =
                "Descargar Documentos Trabajadores Seleccionados";
            } else {
                empresa.txtEnviarTodos = empresa.txtEnviarTodosResp;
                empresa.txtActualizarDocs = "Actualizar Documentos";
                empresa.txtDescargarDocumentos = "Descargar Documentos";
            }

            empresa.isLoadingTrabajadores = true;
            let url = `${
                this.urlBase +
                apiUrls.general.getTrabajadoresEmpresa +
                empresa.idEmpresa
            }/${this.tipoDocumento != null ? this.tipoDocumento.valor : "null"}/${
                this.mesSeleccionado != null ? this.mesSeleccionado.valor : "null"
            }/${
                this.periodoSeleccionado != null
                ? this.periodoSeleccionado.valor
                : "null"
            }`;

            axios({
                method: "POST",
                url: url,
                data: {
                filtrarPorPeriodo: this.mostrarPeriodo,
                paginacionTrabajadores: {
                    actual: empresa.paginacion.current,
                    tamanioPagina: empresa.paginacion.pageSize,
                    filtrosTrabajadores: empresa.trabajadoresFiltrados,
                    filtros: empresa.opcionSeleccionadaFiltro,
                },
                },
                headers: {
                Authorization: `${this.tokenLogin}`,
                },
            })
                .then(
                (result) => {
                    empresa.trabajadores = result.data.trabajadores;
                    empresa.totalTrabajadoresDocumentos =
                    result.data.totalDocumentosTrab;
                    empresa.totalTrabajadores = result.data.totalTrabajadores;

                    if (empresa.totalTrabajadoresDocumentos > 0) {
                    empresa.hayDocumentosTrabajador = true;
                    }
                    const pagination = { ...empresa.paginacion };
                    pagination.total = result.data.totalTrabajadores;
                    pagination.empresa = empresa;
                    empresa.paginacion = pagination;

                    this.actualizarFiltro(empresa);
                },
                (error) => {
                    this.mostrarNotificaciones(3, error.response.data.mensajeGeneral);
                }
                )
                .finally(() => {
                empresa.isLoadingTrabajadores = false;
                });
        },
        enviarRevision: function(){
        

            this.isLoadingEnviandoEmpresa = true
            this.empresaEnviar.enviandoEmpresa = true
            
            
            
            
            this.mostrarModalEnvioEmpresa = false
            this.mostrarNotificaciones(1, `Enviando empresa ${this.empresaEnviar.codEmpresa}`)
            
            
            let url = this.urlBase + apiUrls.remuneraciones.enviarEmpresaRevision

            axios({
                method: "POST", 
                "url": url,
                "data": {
                    "datosEnvio": {
                        "modificarCorreoEmpresa": this.modificarCorreoEmpresa,
                        "tipoDocumento": (this.tipoDocumento != null) ? this.tipoDocumento.valor : null,
                        "mesPeriodo": (this.mesSeleccionado != null) ? this.mesSeleccionado.valor : null,
                        "anioPeriodo": (this.periodoSeleccionado != null) ? this.periodoSeleccionado.valor : null,
                        "empresaEnviar": {
                            "idEmpresa": this.empresaEnviar.idEmpresa,
                            "userNotificar": this.empresaEnviar.userNotificar,
                            "notificar": this.empresaEnviar.notificar
                        },
                        "mostrarPorPeriodo": this.mostrarPeriodo,
                    }
                },
                "headers": {
                    'Authorization': `${this.tokenLogin}`
                }
            }).then(result => {

                this.empresas[this.empresas.indexOf(this.empresaEnviar)].estado = result.data.estadoEmpresa
                if(this.getTrabajadoresInfoEmpresa(this.empresas[this.empresas.indexOf(this.empresaEnviar)].hasOwnProperty('expandirEmpresa'))){
                    this.empresas[this.empresas.indexOf(this.empresaEnviar)].expandirEmpresa = false
                }
                
                this.getTrabajadoresInfoEmpresa(this.empresas[this.empresas.indexOf(this.empresaEnviar)].expandirEmpresa, this.empresas[this.empresas.indexOf(this.empresaEnviar)])
                
                this.mostrarNotificaciones(1, result.data.mensaje)
                
                
                
            }, error => {
                this.mostrarNotificaciones(3, error.response.data.mensaje)
                
                
            })
            .finally(() => {
                this.isLoadingEnviandoEmpresa = false
                this.empresaEnviar.enviandoEmpresa = false
            });
        },
        refrescarEmpresas: function(){
            this.isRefrescando = true
            this.getTrabajadoresInfoEmpresa(this.tipoDocumento)
        },
        estadoEmpresa: function (empresa) {
            let mensajeEstadoEmp = "";
            if(empresa.estado == 1){
                 mensajeEstadoEmp = "En revision"
            } else if(empresa.estado == 2){
                mensajeEstadoEmp = "Rechazado"
            } else if(empresa.estado == 3){
                mensajeEstadoEmp = "Aceptado"
            } else {
                mensajeEstadoEmp = "En Proceso"
            }
            return mensajeEstadoEmp
        },
        estadoPeriodo: function (empresa) {
            let mensajePeriodoEmp = "";
            if(empresa.periodoCerrado == false){
                mensajePeriodoEmp = "Periodo Abierto"
            } else {
                mensajePeriodoEmp = "Periodo Cerrado"
            }
            return mensajePeriodoEmp
        },
        /* METODOS SUBIR ARCHIVO */
        cerrarModalSubirArchivos: function () {
            this.subirDocumentosModal = false;
        },
        subirTodoActivar: function(empresa){
            if(empresa.subidaDocsID == null){
                
                this.$refs.upload.active = true
                this.validarDocsError(empresa)

                    var idInt = setInterval(function(){
                        this.validarDocumentosSubidos(empresa);
                    }.bind(this), 1000);
                    empresa.subidaDocsID = idInt
                }
        },
        validarDocsError: function(empresa){
            empresa.archivosSubir.forEach(archivo => {
                if(!archivo.success && archivo.error != ""){
                this.$refs.upload.update(archivo, {active: true,error: '',progress: '0.00'})
                }
        });

        },
        inputFile(newFile, oldFile) {
        if (newFile && oldFile) {
            // update
            
            if (newFile.active && !oldFile.active) {
            // beforeSend
            // min size
            if (
                newFile.size >= 0 &&
                this.minSize > 0 &&
                newFile.size < this.minSize
            ) {
            
                this.$refs.upload.update(newFile, { error: "size" });
            }
            }
            if (newFile.progress !== oldFile.progress) {
            // progress
            
            }
            if (newFile.error && !oldFile.error) {
            // error
            }
            if (newFile.success && !oldFile.success) {
            // success
                this.empresasFiltradas.forEach(empresa => {
                    if(newFile.response.idEmpresa == empresa.idEmpresa){
                        let haySinTerminar = false
                        empresa.archivosSubir.forEach(archivo =>{
                            if(archivo.active)
                                haySinTerminar = true
                            
                        })
                        if(!haySinTerminar){
                            this.getTrabajadoresInfoEmpresa(true, empresa)
                        }
                    }
                })
            
            }
        }
        if (!newFile && oldFile) {
            // remove
            if (oldFile.success && oldFile.response.id) {
            // $.ajax({
            //   type: 'DELETE',
            //   url: '/upload/delete?id=' + oldFile.response.id,
            // })
            }
        }
        // Automatically activate upload
        if (
            Boolean(newFile) !== Boolean(oldFile) ||
            oldFile.error !== newFile.error
        ) {
            if (this.uploadAuto && !this.$refs.upload.active) {
            this.$refs.upload.active = true;
            }
        }

        },
        alert(message) {
            alert(message);
        },
        onEditFileShow(file) {
            this.editFile = { ...file, show: true };
            this.$refs.upload.update(file, { error: "edit" }); 
        },
        onAddData() {
            this.addData.show = false;
            if (!this.$refs.upload.features.html5) {
                this.alert("Your browser does not support");
                return;
            }
            let file = new window.File([this.addData.content], this.addData.name, {
                type: this.addData.type,
            });
                this.$refs.upload.add(file);
        },
    }

}
</script>

<style>
.margenes {
    margin: 5px
}
.centrar_row{
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: 100%;                           
}

</style>